import { render, staticRenderFns } from "./resumenLibrosObsequiosGerencia.vue?vue&type=template&id=3b1de062"
import script from "./resumenLibrosObsequiosGerencia.vue?vue&type=script&lang=js"
export * from "./resumenLibrosObsequiosGerencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports